import Vue from 'vue';

export default {
  state: {
    downloadItems: [],
    downloadChannel: '',
    downloadDialog: false,
    downloadWaitNumber: 0,
    waitDownloadDialog: false,
    downloadErrorDialog: false,
  },
  getters: {
    downloadItems(state) {
      return state.downloadItems;
    },
    downloadChannel(state) {
      return state.downloadChannel;
    },
    downloadWaitNumber(state) {
      return state.downloadWaitNumber || 0;
    },
    downloadDialog(state) {
      return state.downloadDialog;
    },
    waitDownloadDialog(state) {
      return state.waitDownloadDialog;
    },
    downloadErrorDialog(state) {
      return state.downloadErrorDialog;
    },
  },
  mutations: {
    PUSH_DOWNLOAD_ITEM(state, payload) {
      state.downloadItems.push(payload);
    },
    PULL_FIRST_DOWNLOAD_ITEM(state) {
      state.downloadItems.shift();
    },
    SET_DOWNLOAD_CHANNEL(state, payload) {
      state.downloadChannel = payload;
    },
    CLEAN_DOWNLOAD_QUEUE(state) {
      state.downloadItems = [];
      state.downloadChannel = '';
      state.downloadWaitNumber = 0;
      state.downloadDialog = false;
      state.waitDownloadDialog = false;
      state.downloadErrorDialog = false;
    },
    SET_DOWNLOAD_DIALOG(state, payload) {
      state.downloadDialog = payload;
      state.waitDownloadDialog = false;
    },
    SET_DOWNLOAD_ERROR_DIALOG(state, payload) {
      state.downloadErrorDialog = payload;
    },
    SET_WAIT_DOWNLOAD_DIALOG(state, payload) {
      state.waitDownloadDialog = payload;
    },
    INCREMENT_DOWNLOAD_WAIT_NUMBER(state) {
      state.downloadWaitNumber += 1;
    },
    DECREMENT_DOWNLOAD_WAIT_NUMBER(state) {
      if (state.downloadWaitNumber > 0) {
        state.downloadWaitNumber -= 1;
      }
    },
  },
  actions: {
    LISTEN_DOWNLOAD_EVENT({ state, commit, dispatch }) {
      window.Echo.private(state.downloadChannel)
        .listen('.reportGenerated', (event) => {
          if (event.filename !== 'errorCatch') {
            commit('PUSH_DOWNLOAD_ITEM', event);
            commit('SET_DOWNLOAD_DIALOG', true);
          } else {
            commit('SET_DOWNLOAD_ERROR_DIALOG', true);
            commit('PULL_FIRST_DOWNLOAD_ITEM');
          }
          commit('DECREMENT_DOWNLOAD_WAIT_NUMBER');
          dispatch('LEAVE_DOWNLOAD_EVENT');
        });
    },
    LEAVE_DOWNLOAD_EVENT({ state }) {
      if (state.downloadWaitNumber < 1) {
        window.Echo.leave(state.downloadChannel);
      }
    },
    SEND_DOWNLOAD_REQUEST({ commit, state, dispatch }, payload) {
      if (state.downloadWaitNumber === 0) {
        dispatch('LISTEN_DOWNLOAD_EVENT');
      }
      commit('INCREMENT_DOWNLOAD_WAIT_NUMBER');
      return new Promise((resolve, reject) => {
        Vue.axios.post(payload.route, {
          ...payload.params,
        }).then(() => {
          commit('SET_WAIT_DOWNLOAD_DIALOG', true);
          resolve('all good');
        }).catch((error) => {
          commit('DECREMENT_DOWNLOAD_WAIT_NUMBER');
          dispatch('LEAVE_DOWNLOAD_EVENT');
          reject(error);
        });
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/download.js